type ViewMode = 'monthly' | 'weekly' | 'daily'

interface ViewModeToggleProps {
  value: ViewMode
  onChange: (mode: ViewMode) => void
  className?: string
}

export default function ViewModeToggle({
  value,
  onChange,
  className = '',
}: ViewModeToggleProps) {
  const modes: { value: ViewMode; label: string }[] = [
    { value: 'monthly', label: 'Month' },
    { value: 'weekly', label: 'Week' },
    { value: 'daily', label: 'Day' },
  ]

  return (
    <div className={`inline-flex rounded-lg border border-gray-300 bg-white p-1 ${className}`}>
      {modes.map((mode) => (
        <button
          key={mode.value}
          onClick={() => onChange(mode.value)}
          className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
            value === mode.value
              ? 'bg-indigo-600 text-white'
              : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
          }`}
        >
          {mode.label}
        </button>
      ))}
    </div>
  )
}

export type { ViewMode }
